/**
 * Browser exceptions that are reported as errors but are not faults, shared by both error
 * trackers: PostHog's `before_send` (`dropBenignExceptions` in `./posthog.ts`) and Sentry's
 * `ignoreErrors` (`src/instrumentation-client.ts`). One list, so the two cannot disagree about what
 * counts as noise. Matched on the message, since neither error carries a useful stack.
 *
 * Add a pattern only with evidence that it is noise, and say what the evidence was.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();export const BENIGN_EXCEPTIONS: RegExp[] = [
  /**
   * `ResizeObserver loop completed with undelivered notifications` (and its older spelling,
   * `ResizeObserver loop limit exceeded`) means a layout observer changed a size that was being
   * observed, so the browser delivered the rest of the notifications one frame later. The spec
   * defines it as a report, not a failure: nothing breaks and the page renders the same. Every
   * framework with a transition that measures itself — the register form's step changes here — can
   * trigger it. Sentry already drops it through its own inbound filter; PostHog did not.
   */
  /^ResizeObserver loop (completed with undelivered notifications|limit exceeded)/,
  /**
   * `InvalidStateError: Transition was aborted because of invalid state. Document hidden` is the
   * View Transitions API declining to animate in a document that is not visible. React's
   * `<ViewTransition>` in `page-transition.tsx` starts one for every transition; when the tab is
   * hidden the browser refuses, React reports it as a recoverable error, and the update itself
   * completes without the crossfade. Nothing a visitor sees goes wrong.
   *
   * Evidence (Sentry LANDINGPAGE-4X, checked 2026-09-30): all 37 production events in 30 days came
   * from Meta's own network (AS32934 — `173.252.64.0/18`, `66.220.144.0/20`, `31.13.64.0/18`, in
   * Meta's data-centre towns), i.e. its link and ad-review crawlers rendering the page in a hidden
   * tab. The two remaining events were a local `next start`. No visitor ever reported it.
   *
   * Unanchored and matched through to "Document hidden", so the wrapped form Next.js re-throws
   * (`Error: InvalidStateError: …`) is caught too, while any *other* reason a transition is aborted
   * still reaches both trackers.
   */
  /Transition was aborted because of invalid state\. Document hidden/,
]
